import type {
  Geolocation,
  PersonalizationDataType,
  CoordinatesType,
} from "../types/bopis";

const getGeolocationData = (
  personalizationData: PersonalizationDataType,
  market: string
): Geolocation => {
  const {zipCode: postalCode = "", geoCoordinates = {} as CoordinatesType} =
    personalizationData;

  const {latitude = "", longitude = ""} = geoCoordinates;
  const zipCodeValidation =
    market === "ca"
      ? /^([a-ceghj-npr-tvxy]\d[a-ceghj-npr-z]) ?(\d[a-ceghj-npr-z]\d)?/
      : /^[0-9]{5}?$/;
  let zip = postalCode.substring(0, 5);

  if (market === "ca") {
    zip = postalCode.substring(0, 3);
  }

  if (!zipCodeValidation.test(zip.toLowerCase())) {
    return {
      postalCode: "",
      latitude: "",
      longitude: "",
    };
  }
  return {
    postalCode: zip,
    latitude,
    longitude,
  };
};

export default getGeolocationData;
